import React, { FC, useCallback } from 'react';
import Form, { FormFooter, FormHeader } from '@atlaskit/form';
import Button, { ButtonGroup } from '@atlaskit/button';
import './decision-table-confirmation-modal.scss';

interface RequestModalProps {
  onEdit: () => void;
  closeModal: () => void;
}

const DecisionTableConfirmationModal: FC<RequestModalProps> = ({ onEdit, closeModal }) => {
  const handleFormSubmit = useCallback(() => {
    closeModal();
    onEdit();
  }, [onEdit, closeModal]);
  return (
    <Form onSubmit={handleFormSubmit}>
      {({ formProps }) => (
        <div className="modal-form-wrapper" data-testid="decision-table-confirmation-modal">
          <form {...formProps}>
            <FormHeader
              title={
                <div className="modal-title-wrapper">
                  <span className="modal-title">Are you sure?</span>
                </div>
              }
            ></FormHeader>
            <p>
              Editing the rules could have impacts to the approval process. Any approval requests that are currently in
              progress will be unaffected by these rule edits.
            </p>
            <FormFooter align="end">
              <ButtonGroup>
                <Button appearance="subtle" onClick={closeModal} testId="cancel-btn">
                  Cancel
                </Button>
                <Button type="submit" autoFocus appearance="primary" testId="submit-btn">
                  Begin edits
                </Button>
              </ButtonGroup>
            </FormFooter>
          </form>
        </div>
      )}
    </Form>
  );
};

export default DecisionTableConfirmationModal;
